module.exports = __webpack_public_path__ + "friend-referral.svg?dc39c76cc732b2a7451d9e4fc0acf966";